import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	advisor: AgentAssignedListItemResponseDTO;
	approving: boolean;
	onApprove: () => void;
	onRefuse: () => void;
};

export const AdvisorPendingPickerRow: FC<Props> = ({
	advisor,
	approving,
	onApprove,
	onRefuse,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={theme.spacingTokens.md}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.sm}
			borderBottom={theme.colors.border.solid(theme.palette.grey[100])}
		>
			<InitialsAvatar
				name={advisor.name}
				photo={advisor.avatar ?? undefined}
				size={36}
				muted
				initialsVariant="button"
				flexShrink={0}
			/>
			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyMedium" sx={{ overflowWrap: "anywhere" }}>
					{advisor.name}
				</Typography>
				{advisor.role && (
					<Typography
						variant="caption"
						color={theme.palette.grey[500]}
						sx={{ overflowWrap: "anywhere" }}
					>
						{advisor.role}
					</Typography>
				)}
				<Stack
					direction="row"
					alignItems="center"
					gap={theme.spacingTokens.lg}
					mt={theme.spacingTokens.sm}
				>
					<Button
						variant="primary"
						size="small"
						loading={approving}
						onClick={onApprove}
					>
						{t(Resources.Advisor.approve)}
					</Button>
					<Button
						variant="textLink"
						color="neutral"
						disabled={approving}
						onClick={onRefuse}
						sx={{
							minHeight: theme.spacing(theme.spacingTokens.xxl),
							px: theme.spacingTokens.xs,
						}}
					>
						{t(Resources.Advisor.refuse)}
					</Button>
				</Stack>
			</Stack>
		</Stack>
	);
};
